// extracted by mini-css-extract-plugin
module.exports = {"vendorLogo":"VendorLogo_vendorLogo__5609D"};